// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { TextFieldProps } from "@turnerBlueprint/MobiusOverrides/TextField/TextField";
import { xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

customerAddressFormFieldStyles.container = {
    gap: 12,
};

customerAddressFormFieldStyles.firstNameGridItem = {
    width: 6,
    css: css`
        padding-right: 11px;
    `,
};

customerAddressFormFieldStyles.lastNameGridItem = {
    width: 6,
    css: css`
        padding-left: 11px;
    `,
};

customerAddressFormFieldStyles.companyNameGridItem = {
    width: 6,
    css: css`
        padding-right: 11px;
    `,
};

customerAddressFormFieldStyles.attentionGridItem = {
    width: 6,
    css: css`
        padding-left: 11px;
    `,
};

customerAddressFormFieldStyles.cityGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        padding-right: 11px;

        ${xScreen("lte", "xs")} {
            padding-right: 6px;
        }
    `,
};

customerAddressFormFieldStyles.stateGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        padding-left: 11px;
        padding-right: 11px;

        ${xScreen("lte", "xs")} {
            padding-left: 6px;
        }
    `,
};

customerAddressFormFieldStyles.postalCodeGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        ${xScreen("lte", "xs")} {
            padding-left: 11px;
            padding-right: 6px;
        }
    `,
};
customerAddressFormFieldStyles.phoneGridItem = {
    width: 6,
    css: css`
        padding-right: 11px;
    `,
};
customerAddressFormFieldStyles.faxGridItem = {
    width: 6,
    css: css`
        padding-left: 11px;
    `,
};

customerAddressFormFieldStyles.emailGridItem = {
    css: css`
        ${({ faxVisible }: any) =>
            faxVisible
                ? css`
                      padding-right: 11px;

                      ${xScreen("lte", "xs")} {
                          padding-right: 6px;
                      }
                  `
                : css`
                      padding-left: 11px;
                  `}
    `,
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("First Name"),
    type: "firstName",
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Last Name"),
    type: "lastName",
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Company Name"),
    type: "comapnyName",
} as TextFieldProps;

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Attention"),
} as TextFieldProps;

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Address"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Appartment, Suite (Optional)"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Address3"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Address4"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("City Name"),
    type: "city",
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("ZIP"),
    type: "postalCodeUS",
} as TextFieldProps;

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("(___) ___-____"),
    type: "phone",
} as TextFieldProps;

customerAddressFormFieldStyles.faxText = {
    placeholder: translate("Fax"),
} as TextFieldProps;

customerAddressFormFieldStyles.emailText = {
    placeholder: translate("Email@Address.com"),
    type: "email",
} as TextFieldProps;
